<template>
  <a-modal
    title="地图选点"
    :visible="visible"
    :width="1000"
    :footer="null"
    class="map-picker-modal"
    @cancel="handleCancel"
  >
    <a-row :gutter="16">
      <a-col :span="16">
        <div id="mapPickerContainer" style="width: 100%; height: 500px"></div>
      </a-col>
      <a-col :span="8">
        <div class="map-search-wrapper" style="margin-bottom: 12px">
          <a-input-search
            v-model:value="searchKeyword"
            placeholder="搜索地点名称"
            @search="handleSearch"
            @pressEnter="handleSearch"
            @change="handleSearchChange"
            allow-clear
            class="map-search-input"
            :loading="searching"
          >
            <template v-slot:enterButton>
              <a-button type="primary"> <a-icon type="search" />搜索 </a-button>
            </template>
          </a-input-search>
        </div>
        <div
          style="
            max-height: 300px;
            overflow-y: auto;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 8px;
          "
        >
          <div
            v-if="searchResults.length === 0 && !searching"
            style="text-align: center; color: #999; padding: 20px"
          >
            请输入地点名称进行搜索
          </div>
          <a-spin :spinning="searching" tip="搜索中...">
            <div
              v-for="(item, index) in searchResults"
              :key="index"
              @click="selectSearchResult(item)"
              style="
                padding: 8px;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
                transition: background 0.3s;
              "
              :style="{
                background: selectedResultIndex === index ? '#e6f7ff' : '#fff',
              }"
              @mouseenter="$event.target.style.background = '#f5f5f5'"
              @mouseleave="
                $event.target.style.background =
                  selectedResultIndex === index ? '#e6f7ff' : '#fff'
              "
            >
              <div style="font-weight: 500; color: #1890ff; margin-bottom: 4px">
                {{ item.name }}
              </div>
              <div style="font-size: 12px; color: #666">
                {{ item.address || item.district }}
              </div>
            </div>
          </a-spin>
        </div>
      </a-col>
    </a-row>
    <div style="margin-top: 16px">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-input-group compact>
            <a-input
              addon-before="经度"
              v-model:value="selectedLng"
              readonly
              style="width: calc(100% - 60px)"
            />
          </a-input-group>
        </a-col>
        <a-col :span="12">
          <a-input-group compact>
            <a-input
              addon-before="纬度"
              v-model:value="selectedLat"
              readonly
              style="width: calc(100% - 60px)"
            />
          </a-input-group>
        </a-col>
      </a-row>
      <a-input
        v-model:value="selectedAddress"
        placeholder="详细地址（可手动编辑）"
        style="margin-top: 12px"
      />
      <a-input
        v-model:value="selectedDetailAddress"
        placeholder="完整地址信息（可手动编辑）"
        type="textarea"
        :rows="2"
        
        style="margin-top: 12px"
      />
      <div style="margin-top: 16px; text-align: right">
        <a-button @click="handleCancel" style="margin-right: 8px"
          >取消</a-button
        >
        <a-button type="primary" @click="handleConfirm">确认选择</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
export default {
  name: 'MapPicker',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    longitude: {
      type: [String, Number],
      default: null,
    },
    latitude: {
      type: [String, Number],
      default: null,
    },
    address: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      placeSearch: null,
      selectedLng: '',
      selectedLat: '',
      selectedAddress: '',
      selectedDetailAddress: '',
      searchKeyword: '',
      searchResults: [],
      searching: false,
      selectedResultIndex: -1,
      // 高德地图配置
      // 可以从环境变量读取，优先使用环境变量
      amapConfig: {
        // Web 服务端 Key（用于 REST API）
        // 注意：Web 服务端 Key 不能用于 Web 端 JS API，但可以用于 REST API
        key: process.env.VUE_APP_AMAP_KEY || '76648a408dd16ee1514b4130e09f190e',
        // 安全密钥（私钥）- 优先使用环境变量，否则使用配置的值
        securityJsCode: process.env.VUE_APP_AMAP_SECURITY_JS_CODE || 'fe79822f2cc2eb15c15ad267fe5f6745',
        // Web 端 JS API 版本（如果 JS API 可用）
        version: '1.4.15',
        // Web 服务端 Key 用于 REST API
        restApiKey: process.env.VUE_APP_AMAP_REST_API_KEY || '76648a408dd16ee1514b4130e09f190e',
      },
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initSelectedValues()
        this.$nextTick(() => {
          this.loadAmapScript()
            .then(() => {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.initMap()
                }, 200)
              })
            })
            .catch((error) => {
              console.error('地图加载错误:', error)
              this.$message.error(
                error.message || '地图加载失败，请检查网络连接或配置高德地图Key'
              )
            })
        })
      } else {
        this.destroyMap()
      }
    },
  },
  methods: {
    // 初始化选中值
    initSelectedValues() {
      if (this.longitude && this.latitude) {
        this.selectedLng = String(this.longitude)
        this.selectedLat = String(this.latitude)
        this.selectedAddress = this.address || ''
        this.selectedDetailAddress = this.address || ''
      } else {
        this.selectedLng = ''
        this.selectedLat = ''
        this.selectedAddress = ''
        this.selectedDetailAddress = ''
      }
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedResultIndex = -1
      this.searching = false
    },
    // 加载高德地图脚本
    loadAmapScript() {
      // 如果已经加载过，检查插件是否也加载了
      if (window.AMap && window.AMap.Map && window.AMap.Geocoder && window.AMap.PlaceSearch && window.AMap.Geolocation) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const amapKey = this.amapConfig.key
        const securityJsCode = this.amapConfig.securityJsCode

        // 验证 Key 配置
        if (!amapKey || amapKey === 'YOUR_AMAP_KEY') {
          reject(new Error('高德地图 Key 未配置，请在环境变量或代码中配置 VUE_APP_AMAP_KEY'))
          return
        }

        console.log('加载高德地图')
        console.log('配置信息:', {
          jsApiKey: amapKey.substring(0, 8) + '...',
          restApiKey: (this.amapConfig.restApiKey || amapKey).substring(0, 8) + '...',
          securityJsCode: securityJsCode ? (securityJsCode.substring(0, 8) + '...') : '未配置',
          securityJsCodeStatus: securityJsCode ? '已配置' : '未配置',
          jsApiType: 'Web 端 JS API (如果可用)',
          restApiType: 'Web 服务端 API (备用方案)',
          apiUrl: 'webapi.amap.com',
          version: this.amapConfig.version,
        })

        // 检查是否已经有脚本标签
        const existingScript = document.querySelector(
          'script[src*="webapi.amap.com"]'
        )
        if (existingScript) {
          // 如果脚本已存在，等待加载完成（包括插件）
          const checkInterval = setInterval(() => {
            if (window.AMap && window.AMap.Map && window.AMap.Geocoder && window.AMap.PlaceSearch) {
              clearInterval(checkInterval)
              resolve()
            }
          }, 100)

          // 10秒超时
          setTimeout(() => {
            clearInterval(checkInterval)
            if (!window.AMap || !window.AMap.Map) {
              reject(
                new Error('高德地图加载超时，请检查网络连接或配置高德地图Key')
              )
            } else if (!window.AMap.Geocoder || !window.AMap.PlaceSearch) {
              reject(
                new Error('高德地图插件加载超时，请刷新页面重试')
              )
            }
          }, 10000)
          return
        }

        const script = document.createElement('script')
        script.type = 'text/javascript'

        script.onerror = () => {
          reject(new Error('高德地图加载失败，请检查网络连接或配置高德地图Key'))
        }

        // 使用唯一回调名，避免多次加载冲突
        const callbackName = 'initAMap_' + Date.now()
        window[callbackName] = () => {
          // 确保AMap对象和插件已完全加载
          if (window.AMap && window.AMap.Map && window.AMap.Geocoder && window.AMap.PlaceSearch) {
            delete window[callbackName]
            console.log('高德地图及插件加载成功')
            resolve()
          } else {
            // 如果插件未加载，等待一下再检查
            setTimeout(() => {
              if (window.AMap && window.AMap.Map && window.AMap.Geocoder && window.AMap.PlaceSearch) {
                delete window[callbackName]
                console.log('高德地图及插件加载成功（延迟）')
                resolve()
              } else {
                delete window[callbackName]
                reject(new Error('高德地图插件初始化失败，请刷新页面重试'))
              }
            }, 500)
          }
        }

        // 构建 Web 端 JS API 脚本 URL
        // 使用 webapi.amap.com 是 Web 端 JS API 的标准地址
        // 如果配置了安全密钥则添加到 URL 参数中
        // 插件列表：PlaceSearch(地点搜索), Geocoder(地理编码), Geolocation(定位)
        let scriptUrl = `https://webapi.amap.com/maps?v=${this.amapConfig.version}&key=${amapKey}&plugin=AMap.PlaceSearch,AMap.Geocoder,AMap.Geolocation&callback=${callbackName}`
        if (securityJsCode) {
          scriptUrl += `&securityJsCode=${securityJsCode}`
          console.log('已添加安全密钥到请求 URL')
        }
        
        script.src = scriptUrl
        script.async = true
        document.head.appendChild(script)
      })
    },
    // 初始化地图
    initMap() {
      const container = document.getElementById('mapPickerContainer')
      if (!container) {
        console.error('地图容器不存在')
        return
      }

      // 如果地图已存在，先销毁
      if (this.map) {
        try {
          this.map.destroy()
        } catch (e) {
          console.warn('销毁地图时出错:', e)
        }
        this.map = null
        this.marker = null
      }

      // 检查AMap是否已加载
      if (!window.AMap || !window.AMap.Map) {
        console.error('高德地图API未加载')
        this.$message.error('高德地图API未加载，请刷新页面重试')
        return
      }

      try {
        // 如果有已有经纬度，使用已有位置，否则使用默认位置（北京）
        const center =
          this.longitude && this.latitude
            ? [parseFloat(this.longitude), parseFloat(this.latitude)]
            : [116.397428, 39.90923]

        this.map = new window.AMap.Map('mapPickerContainer', {
          zoom: 13,
          center: center,
          mapStyle: 'amap://styles/normal',
          viewMode: '2D',
        })

        // 等待地图加载完成
        this.map.on('complete', () => {
          // 初始化地点搜索服务
          try {
            if (window.AMap && window.AMap.PlaceSearch) {
              // 尝试不同的配置方式
              this.placeSearch = new window.AMap.PlaceSearch({
                city: '', // 使用空字符串表示全国搜索，而不是 '全国'
                citylimit: false,
                pageSize: 10,
                pageIndex: 1,
                extensions: 'all', // 返回详细信息
                map: this.map, // 可选：关联地图实例，用于在地图上显示搜索结果
                panel: null, // 不自动显示结果面板，我们自己控制显示
              })
              console.log('搜索服务初始化成功', {
                placeSearch: this.placeSearch,
                hasSearchMethod: typeof this.placeSearch.search === 'function'
              })
            } else {
              console.error('PlaceSearch 插件未加载', {
                hasAMap: !!window.AMap,
                hasPlaceSearch: !!(window.AMap && window.AMap.PlaceSearch)
              })
              this.$message.warning('搜索功能初始化失败：PlaceSearch 插件未加载')
            }
          } catch (e) {
            console.error('初始化搜索服务失败:', e)
            this.$message.warning('搜索功能初始化失败，但地图可以正常使用')
          }

          // 如果已有经纬度，添加标记
          if (this.longitude && this.latitude) {
            this.addMarker(center)
            this.getAddressByLngLat(center)
          } else {
            // 如果没有已有位置，获取当前位置
            this.getCurrentLocation()
          }
        })

        // 地图点击事件
        this.map.on('click', (e) => {
          const lng = e.lnglat.getLng()
          const lat = e.lnglat.getLat()
          this.selectedLng = lng.toFixed(6)
          this.selectedLat = lat.toFixed(6)
          this.addMarker([lng, lat])
          this.getAddressByLngLat([lng, lat])
          this.selectedResultIndex = -1
        })
      } catch (error) {
        console.error('初始化地图失败:', error)
        this.$message.error('地图初始化失败: ' + (error.message || '未知错误'))
      }
    },
    // 获取当前位置
    getCurrentLocation() {
      if (!this.map) {
        console.warn('地图未初始化，无法获取当前位置')
        return
      }

      // 优先使用高德地图定位API
      if (window.AMap && window.AMap.Geolocation) {
        const geolocation = new window.AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位
          timeout: 10000, // 超过10秒后停止定位
          maximumAge: 0, // 定位结果缓存0毫秒
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标
          showButton: false, // 不显示定位按钮
          buttonDom: '', // 定位按钮的DOM容器
          showMarker: false, // 不显示定位标记
          showCircle: false, // 不显示定位精度圆圈
          panToLocation: false, // 定位成功后不自动调整地图视野
          zoomToAccuracy: false, // 定位成功后不自动调整地图缩放级别
        })

        geolocation.getCurrentPosition((status, result) => {
          console.log('高德定位结果:', { status, result })
          
          if (status === 'complete') {
            const { position } = result
            const lng = position.lng
            const lat = position.lat
            
            console.log('获取到当前位置:', { lng, lat })
            
            // 更新选中位置
            this.selectedLng = lng.toFixed(6)
            this.selectedLat = lat.toFixed(6)
            
            // 定位到当前位置
            this.map.setCenter([lng, lat])
            this.map.setZoom(15)
            
            // 添加标记
            this.addMarker([lng, lat])
            
            // 获取地址
            this.getAddressByLngLat([lng, lat])
            
            this.$message.success('已定位到当前位置')
          } else {
            console.error('高德定位失败:', result)
            // 如果高德定位失败，尝试使用浏览器定位
            this.getCurrentLocationByBrowser()
          }
        })
      } else {
        // 如果高德定位API不可用，使用浏览器定位
        this.getCurrentLocationByBrowser()
      }
    },
    // 使用浏览器定位API获取当前位置
    getCurrentLocationByBrowser() {
      if (!navigator.geolocation) {
        console.warn('浏览器不支持定位功能')
        this.$message.warning('浏览器不支持定位功能，请手动选择位置')
        return
      }

      console.log('使用浏览器定位API获取当前位置...')
      this.$message.info('正在获取当前位置...', 2)

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          console.log('浏览器定位成功:', { latitude, longitude })
          
          // 更新选中位置
          this.selectedLng = longitude.toFixed(6)
          this.selectedLat = latitude.toFixed(6)
          
          // 定位到当前位置
          if (this.map) {
            this.map.setCenter([longitude, latitude])
            this.map.setZoom(15)
            
            // 添加标记
            this.addMarker([longitude, latitude])
            
            // 获取地址
            this.getAddressByLngLat([longitude, latitude])
            
            this.$message.success('已定位到当前位置')
          }
        },
        (error) => {
          console.error('浏览器定位失败:', error)
          let errorMessage = '定位失败'
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = '定位权限被拒绝，请在浏览器设置中允许定位权限'
              break
            case error.POSITION_UNAVAILABLE:
              errorMessage = '定位信息不可用'
              break
            case error.TIMEOUT:
              errorMessage = '定位请求超时'
              break
          }
          this.$message.warning(errorMessage + '，请手动选择位置', 5)
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      )
    },
    // 搜索输入变化处理
    handleSearchChange(e) {
      // 输入变化时不做处理，等待用户点击搜索或按回车
    },
    // 搜索地点
    handleSearch(value) {
      // 如果传入了值，使用传入的值，否则使用 searchKeyword
      const keyword = value || this.searchKeyword
      
      if (!keyword || !keyword.trim()) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      if (!this.placeSearch) {
        this.$message.error('搜索服务未初始化，请等待地图加载完成')
        return
      }

      // 验证 placeSearch 对象是否有 search 方法
      if (typeof this.placeSearch.search !== 'function') {
        console.error('placeSearch.search 不是函数:', this.placeSearch)
        this.$message.error('搜索服务异常，请刷新页面重试')
        return
      }

      this.searching = true
      this.searchResults = []
      this.selectedResultIndex = -1

      const searchKeyword = keyword.trim()
      console.log('开始搜索:', searchKeyword)
      console.log('placeSearch 对象:', this.placeSearch)
      console.log('当前 Key:', this.amapConfig.key ? this.amapConfig.key.substring(0, 8) + '...' : '未配置')
      
      try {
        this.placeSearch.search(searchKeyword, (status, result) => {
          this.searching = false
          
          // 调试信息
          console.log('搜索回调状态:', { 
            status, 
            result, 
            keyword: searchKeyword,
            resultType: typeof result,
            resultKeys: result ? Object.keys(result) : []
          })
          
          // 处理搜索结果
          if (status === 'complete') {
            if (result && result.info === 'OK') {
              if (result.poiList && result.poiList.pois && result.poiList.pois.length > 0) {
                this.searchResults = result.poiList.pois.map((poi) => ({
                  name: poi.name,
                  address: poi.address,
                  district: poi.district,
                  location: poi.location,
                  tel: poi.tel,
                  type: poi.type,
                  fullAddress: poi.address
                    ? `${poi.district}${poi.address}`
                    : poi.district,
                }))
              } else {
                this.searchResults = []
                this.$message.info('未找到相关地点')
              }
            } else {
              // 搜索完成但结果不是OK
              this.searchResults = []
              const errorInfo = result?.info || result?.message || '未知错误'
              const errorCode = result?.infocode || ''
              console.error('搜索失败详情:', { 
                status, 
                result, 
                errorInfo, 
                errorCode,
                fullResult: JSON.stringify(result, null, 2)
              })
              
              // 根据错误码提供更友好的提示
              let userMessage = '搜索失败，请重试'
              if (errorInfo.includes('INVALID_USER_KEY') || errorInfo.includes('USERKEY')) {
                userMessage = '搜索服务配置错误，请检查高德地图Key配置'
              } else if (errorInfo.includes('INVALID_USER_DOMAIN')) {
                userMessage = '搜索服务域名白名单配置错误，请检查高德地图控制台配置'
              } else if (errorInfo.includes('DAILY_QUERY_OVER_LIMIT')) {
                userMessage = '搜索服务调用次数超限，请稍后再试'
              } else if (errorInfo) {
                userMessage = `搜索失败: ${errorInfo}`
              }
              
              this.$message.error(userMessage)
            }
          } else if (status === 'error') {
            // 搜索出错，尝试使用 REST API 备用方案
            console.error('PlaceSearch 搜索错误，尝试使用 REST API 备用方案:', { 
              status, 
              result, 
              keyword: searchKeyword
            })
            
            // 尝试使用 REST API 进行搜索
            this.searchByRestAPI(searchKeyword).then((restResults) => {
              if (restResults && restResults.length > 0) {
                this.searchResults = restResults
                this.$message.success('搜索成功（使用备用方案）')
              } else {
                // REST API 也失败，显示错误信息
                this.searchResults = []
                const errorInfo = result?.info || result?.message || result?.toString() || '网络错误或服务异常'
                console.error('搜索错误详情:', { 
                  status, 
                  result, 
                  errorInfo,
                  resultType: typeof result,
                  resultString: result ? result.toString() : 'null',
                  fullResult: result ? JSON.stringify(result, null, 2) : 'null'
                })
                
                // 尝试从 result 中提取更多错误信息
                let userMessage = '搜索失败: 网络错误或服务异常'
                if (typeof result === 'string') {
                  userMessage = `搜索失败: ${result}`
                } else if (result && result.info) {
                  userMessage = `搜索失败: ${result.info}`
                } else if (result && result.message) {
                  userMessage = `搜索失败: ${result.message}`
                }
                
                this.$message.error(userMessage)
              }
            }).catch((restError) => {
              // REST API 调用失败
              this.searchResults = []
              const errorInfo = result?.info || result?.message || result?.toString() || '网络错误或服务异常'
              console.error('REST API 搜索也失败:', restError)
              console.error('搜索错误详情:', { 
                status, 
                result, 
                errorInfo,
                resultType: typeof result,
                resultString: result ? result.toString() : 'null',
                fullResult: result ? JSON.stringify(result, null, 2) : 'null'
              })
              
              let userMessage = '搜索失败: 网络错误或服务异常'
              if (typeof result === 'string') {
                userMessage = `搜索失败: ${result}`
              } else if (result && result.info) {
                userMessage = `搜索失败: ${result.info}`
              } else if (result && result.message) {
                userMessage = `搜索失败: ${result.message}`
              }
              
              this.$message.error(userMessage)
            })
          } else if (status === 'no_data') {
            // 无数据
            this.searchResults = []
            this.$message.info('未找到相关地点')
          } else {
            // 其他状态
            this.searchResults = []
            console.warn('搜索未知状态:', { status, result })
            this.$message.warning(`搜索状态异常: ${status}`)
          }
        })
      } catch (error) {
        this.searching = false
        this.searchResults = []
        console.error('搜索调用异常:', error)
        this.$message.error(`搜索调用失败: ${error.message || '未知错误'}`)
      }
    },
    // 使用 REST API 进行搜索（备用方案）
    async searchByRestAPI(keyword) {
      try {
        const amapKey = this.amapConfig.restApiKey || this.amapConfig.key
        const url = `https://restapi.amap.com/v3/place/text?key=${amapKey}&keywords=${encodeURIComponent(keyword)}&city=&offset=10&page=1&extensions=all`
        
        console.log('使用 REST API 搜索:', { keyword, url: url.replace(amapKey, amapKey.substring(0, 8) + '...') })
        
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error(`HTTP 错误: ${response.status} ${response.statusText}`)
        }
        
        const data = await response.json()
        console.log('REST API 搜索响应:', data)
        
        if (data.status === '1' && data.pois && data.pois.length > 0) {
          return data.pois.map((poi) => ({
            name: poi.name,
            address: poi.address,
            district: poi.district,
            location: {
              lng: parseFloat(poi.location.split(',')[0]),
              lat: parseFloat(poi.location.split(',')[1])
            },
            tel: poi.tel,
            type: poi.type,
            fullAddress: poi.address
              ? `${poi.district}${poi.address}`
              : poi.district,
          }))
        } else {
          console.warn('REST API 搜索无结果:', data)
          return []
        }
      } catch (error) {
        console.error('REST API 搜索失败:', error)
        throw error
      }
    },
    // 选择搜索结果
    selectSearchResult(item) {
      const location = item.location
      const lng = location.lng
      const lat = location.lat

      this.selectedLng = lng.toFixed(6)
      this.selectedLat = lat.toFixed(6)
      this.selectedAddress = item.address || item.district
      this.selectedDetailAddress =
        item.fullAddress || item.address || item.district

      // 定位到选择的位置
      const position = [lng, lat]
      this.addMarker(position)
      this.map.setCenter(position)
      this.map.setZoom(16)

      // 获取详细地址信息
      this.getAddressByLngLat(position, item)

      // 高亮选中的结果
      this.selectedResultIndex = this.searchResults.findIndex(
        (r) =>
          r.name === item.name &&
          r.location.lng === lng &&
          r.location.lat === lat
      )
    },
    // 添加标记
    addMarker(position) {
      if (this.marker) {
        this.marker.setPosition(position)
      } else {
        this.marker = new window.AMap.Marker({
          position: position,
          draggable: true,
        })
        this.map.add(this.marker)

        // 标记拖拽事件
        this.marker.on('dragend', (e) => {
          const lng = e.lnglat.getLng()
          const lat = e.lnglat.getLat()
          this.selectedLng = lng.toFixed(6)
          this.selectedLat = lat.toFixed(6)
          this.getAddressByLngLat([lng, lat])
        })
      }
      this.map.setCenter(position)
    },
    // 根据经纬度获取地址（逆地理编码）- 使用 REST API 备用方案
    // 注意：REST API 需要使用 Web 服务端 Key
    async getAddressByLngLatRestAPI(lng, lat) {
      try {
        // 使用 Web 服务端 Key 用于 REST API
        const amapKey = this.amapConfig.restApiKey || this.amapConfig.key
        const url = `https://restapi.amap.com/v3/geocode/regeo?key=${amapKey}&location=${lng},${lat}&radius=1000&extensions=all`
        
        console.group('🌐 REST API 请求详情')
        console.log('请求 URL:', url.replace(amapKey, amapKey.substring(0, 8) + '...'))
        console.log('使用的 Web 服务端 Key:', amapKey.substring(0, 8) + '...')
        console.log('完整 Key:', amapKey)
        console.log('当前域名:', window.location.hostname)
        console.log('当前协议:', window.location.protocol)
        console.log('完整 URL:', window.location.href)
        console.log('经纬度:', { lng, lat })
        
        // 尝试获取客户端 IP（通过第三方服务）
        try {
          const ipResponse = await fetch('https://api.ipify.org?format=json')
          const ipData = await ipResponse.json()
          console.log('客户端 IP 地址:', ipData.ip)
          console.warn('⚠️ 注意：前端直接调用 REST API 时，高德服务器看到的是客户端 IP，不是服务器 IP')
          console.warn('⚠️ 如果配置了 IP 白名单，需要添加客户端 IP，而不是服务器 IP')
        } catch (ipError) {
          console.warn('无法获取客户端 IP:', ipError)
        }
        console.groupEnd()
        
        let response
        try {
          response = await fetch(url)
        } catch (fetchError) {
          console.error('❌ 网络请求失败:', fetchError)
          console.error('可能的原因:')
          console.error('  1. CORS 跨域问题（高德 REST API 可能不允许前端直接调用）')
          console.error('  2. 网络连接问题')
          console.error('  3. 防火墙或代理拦截')
          return {
            success: false,
            message: '网络请求失败: ' + (fetchError.message || '未知错误'),
            errorType: 'network',
            suggestion: '建议通过后端代理调用 REST API，避免 CORS 和 IP 白名单问题',
          }
        }
        
        if (!response.ok) {
          console.error('❌ HTTP 响应错误:', response.status, response.statusText)
          const errorText = await response.text()
          console.error('错误响应内容:', errorText)
          return {
            success: false,
            message: `HTTP 错误: ${response.status} ${response.statusText}`,
            errorType: 'http',
            httpStatus: response.status,
          }
        }
        
        let data
        try {
          const responseText = await response.text()
          console.group('📥 REST API 响应详情')
          console.log('响应状态:', response.status, response.statusText)
          console.log('响应头:', Object.fromEntries(response.headers.entries()))
          console.log('原始响应文本:', responseText)
          try {
            data = JSON.parse(responseText)
            console.log('解析后的 JSON 数据:', JSON.stringify(data, null, 2))
          } catch (parseError) {
            console.error('❌ JSON 解析失败:', parseError)
            console.error('响应不是有效的 JSON 格式')
            console.groupEnd()
            return {
              success: false,
              message: '响应解析失败: ' + (parseError.message || '未知错误'),
              errorType: 'parse',
              rawResponse: responseText,
            }
          }
          console.groupEnd()
        } catch (textError) {
          console.error('❌ 读取响应失败:', textError)
          return {
            success: false,
            message: '读取响应失败: ' + (textError.message || '未知错误'),
            errorType: 'read',
          }
        }
        
        // 检查 Key 相关错误
        if (data.status === '0') {
          console.group('❌ REST API 错误详情')
          console.error('错误状态:', data.status)
          console.error('错误信息:', data.info)
          console.error('错误码:', data.infocode)
          console.error('请求 URL:', url.replace(amapKey, amapKey.substring(0, 8) + '...'))
          console.error('使用的 Key:', amapKey.substring(0, 8) + '...')
          if (data.sec_code) {
            console.error('安全码:', data.sec_code)
          }
          if (data.sec_code_debug) {
            console.error('安全码调试:', data.sec_code_debug)
          }
          console.error('完整错误响应:', JSON.stringify(data, null, 2))
          console.groupEnd()
          
          // 常见错误码
          const errorMessages = {
            '10000': '请求正常',
            '10001': 'Key 不正确或未过期',
            '10002': '没有权限使用相应的服务或者请求接口的路径拼写错误',
            '10003': '访问已超出日访问量',
            '10004': '单位时间内访问过于频繁',
            '10005': 'IP 白名单出错，发送请求的服务器 IP 不在 IP 白名单内',
            '10006': '绑定域名出错，发送请求的域名不在域名白名单内',
            '10007': '数字签名未通过验证',
            '10008': 'MD5 安全码未通过验证',
            '10009': '请求 Key 与绑定平台不符',
            '10010': 'IP 访问超限',
            '10011': '服务不支持请求的协议，必须是 WebService 服务',
            '10012': '权限不足，服务请求被拒绝',
            '10013': '开发者删除了 Key，Key 被删除后无法正常使用',
            '20000': '请求参数非法',
            '20001': '缺少必填参数',
            '20002': '请求协议非法',
            '20003': '其他未知错误'
          }
          
          const errorMsg = errorMessages[data.infocode] || data.info || '未知错误'
          
          // 根据错误码提供更友好的建议
          let suggestion = '请检查高德地图控制台配置'
          let detailedSuggestions = []
          
          if (data.infocode === '10005') {
            suggestion = 'IP 白名单限制'
            detailedSuggestions = [
              '⚠️ 重要：前端直接调用 REST API 时，高德服务器看到的是客户端 IP，不是服务器 IP',
              '当前问题：客户端 IP 不在白名单中',
              '解决方案 1（推荐）：通过后端代理调用 REST API',
              '   - 前端请求后端接口，后端使用服务器 IP 调用高德 REST API',
              '   - 服务器 IP 通常是固定的，更容易管理白名单',
              '解决方案 2：在高德控制台添加客户端 IP 到白名单',
              '   - 查看控制台输出的客户端 IP 地址',
              '   - 在高德控制台 > 应用管理 > 您的应用 > IP 白名单中添加',
              '   - 注意：客户端 IP 可能经常变化（移动网络、VPN 等）',
              '解决方案 3：如果 IP 白名单配置了服务器 IP，需要改为客户端 IP 或移除白名单限制',
            ]
          } else if (data.infocode === '10006') {
            suggestion = '域名白名单限制'
            detailedSuggestions = [
              '当前域名: ' + window.location.hostname,
              '请在高德控制台添加此域名到白名单',
              '注意：需要包含协议（http:// 或 https://）',
            ]
          } else if (data.infocode === '10009') {
            suggestion = 'Key 平台类型错误'
            detailedSuggestions = [
              '⚠️ 错误码 10009 表示：请求 Key 与绑定平台不符',
              '可能的原因：',
              '  1. Key 的平台类型配置错误（当前使用的是 Web 服务端 Key，应该正确）',
              '  2. Key 在高德控制台中的平台类型设置不正确',
              '  3. Key 被绑定到了错误的平台类型',
              '解决方案：',
              '  1. 在高德控制台检查 Key 的平台类型设置',
              '  2. 确认 Key 的平台类型是"Web 服务"',
              '  3. 如果 Key 类型错误，需要重新创建正确类型的 Key',
              '  4. 检查 Key 的服务权限，确保已开通"Web 服务 API"',
            ]
          } else if (data.infocode === '10001') {
            suggestion = 'Key 不正确或已过期'
            detailedSuggestions = [
              '请检查 Key 是否正确（当前 Key 前8位: ' + this.amapConfig.key.substring(0, 8) + '）',
              '检查 Key 是否已过期',
              '检查 Key 是否被禁用',
            ]
          } else if (data.infocode === '10002') {
            suggestion = '服务权限不足'
            detailedSuggestions = [
              'Key 没有权限使用地理编码服务',
              '请在高德控制台检查 Key 的服务权限',
              '确保"Web 服务 API"已开通',
            ]
          } else if (data.infocode === '10012') {
            suggestion = '权限不足'
            detailedSuggestions = [
              '服务请求被拒绝',
              '请检查 Key 的服务权限配置',
              '确认地理编码服务已开通',
            ]
          }
          
          console.error('REST API Key 错误详情:', {
            infocode: data.infocode,
            message: errorMsg,
            suggestion: suggestion,
            detailedSuggestions: detailedSuggestions,
            currentDomain: window.location.hostname,
            currentKey: this.amapConfig.key.substring(0, 8) + '...',
          })
          
          return {
            success: false,
            message: errorMsg,
            errorCode: data.infocode,
            errorInfo: data.info,
            suggestion: suggestion,
            detailedSuggestions: detailedSuggestions,
          }
        }
        
        if (data.status === '1' && data.regeocode) {
          const regeocode = data.regeocode
          const formattedAddress = regeocode.formatted_address || ''
          const addressComponent = regeocode.addressComponent || {}
          
          // 辅助函数：提取地址组件值（可能是字符串、对象或数组）
          const getAddressValue = (value) => {
            if (!value) return ''
            if (typeof value === 'string') return value
            if (Array.isArray(value)) {
              // 如果是数组，取第一个元素
              return getAddressValue(value[0])
            }
            if (typeof value === 'object') {
              // 优先取 name 属性
              if (value.name) return String(value.name)
              // 如果没有 name，尝试取其他可能的属性
              if (value.value) return String(value.value)
              if (value.text) return String(value.text)
              // 如果都没有，返回空字符串，避免显示 [object Object]
              return ''
            }
            return String(value)
          }
          
          // 提取地址组件值
          const province = getAddressValue(addressComponent.province)
          const city = getAddressValue(addressComponent.city)
          const district = getAddressValue(addressComponent.district)
          const township = getAddressValue(addressComponent.township)
          const street = getAddressValue(addressComponent.street)
          const streetNumber = getAddressValue(addressComponent.streetNumber)
          
          // 构建完整地址，使用数组过滤空值后拼接
          const addressParts = [province, city, district, township, street, streetNumber].filter(Boolean)
          const fullAddress = addressParts.join('')
          
          return {
            success: true,
            address: formattedAddress || fullAddress,
            detailAddress: fullAddress || formattedAddress,
          }
        } else {
          console.error('REST API 地理编码失败:', data)
          
          // 详细错误信息
          const errorInfo = {
            status: data.status,
            info: data.info,
            infocode: data.infocode,
            url: url
          }
          console.error('REST API 错误详情:', errorInfo)
          
          // 常见错误码说明
          const errorMessages = {
            '10001': 'Key 不正确或未过期 - 请检查 Key 是否正确',
            '10002': '没有权限使用相应的服务 - 请检查 Key 的服务权限',
            '10003': '访问已超出日访问量 - 请检查配额',
            '10004': '单位时间内访问过于频繁 - 请稍后重试',
            '10005': 'IP 白名单出错 - 请在高德控制台添加服务器 IP',
            '10006': '绑定域名出错 - 请在高德控制台添加域名白名单',
            '10009': '请求 Key 与绑定平台不符 - 请使用 Web 服务端 Key，而不是 Web 端 Key',
            '10013': '开发者删除了 Key - Key 已被删除',
            '20000': '请求参数非法',
            '20001': '缺少必填参数'
          }
          
          const errorMsg = errorMessages[data.infocode] || data.info || '未知错误'
          console.error('错误说明:', errorMsg)
          
          return {
            success: false,
            message: `REST API 错误: ${errorMsg} (错误码: ${data.infocode || 'N/A'})`,
            errorCode: data.infocode,
            errorInfo: data.info,
            fullError: errorInfo
          }
        }
      } catch (error) {
        console.error('REST API 地理编码异常:', error)
        return {
          success: false,
          message: error.message || '地址解析异常',
        }
      }
    },
    // 根据经纬度获取地址（逆地理编码）
    async getAddressByLngLat(position, searchItem = null) {
      try {
        // 确保 position 格式正确 [lng, lat]
        let lnglat = position
        if (Array.isArray(position)) {
          lnglat = position
        } else if (position && typeof position === 'object' && position.lng && position.lat) {
          lnglat = [position.lng, position.lat]
        } else if (position && typeof position === 'object' && position.getLng && position.getLat) {
          lnglat = [position.getLng(), position.getLat()]
        } else {
          console.error('无效的经纬度格式:', position)
          this.handleGeocodeError(searchItem)
          return
        }

        const [lng, lat] = lnglat

        // 首先尝试使用 JS API
        if (window.AMap && window.AMap.Geocoder) {
          const geocoder = new window.AMap.Geocoder({
            city: '全国',
            radius: 1000,
          })

          geocoder.getAddress(lnglat, async (status, result) => {
            // 处理错误状态
            if (status === 'error' || (result && typeof result === 'string' && result.includes('USERKEY'))) {
              const errorResult = typeof result === 'string' ? result : (result?.result || '未知错误')
              
              // 获取域名信息
              const currentHost = window.location.hostname
              const currentPort = window.location.port
              const currentProtocol = window.location.protocol.replace(':', '')
              const domainWithPort = currentPort ? `${currentHost}:${currentPort}` : currentHost
              
              // 详细的诊断信息
              const diagnosticInfo = {
                status: status,
                result: errorResult,
                errorType: typeof result === 'string' ? '字符串错误' : '对象错误',
                apiType: 'Web 端 JS API', // 明确标识使用的 API 类型
                apiUrl: 'webapi.amap.com',
                currentKey: this.amapConfig.key.substring(0, 8) + '...',
                securityJsCode: this.amapConfig.securityJsCode ? (this.amapConfig.securityJsCode.substring(0, 8) + '...') : '未配置',
                hasSecurityJsCode: !!this.amapConfig.securityJsCode,
                currentDomain: currentHost,
                currentPort: currentPort || '默认端口',
                currentProtocol: currentProtocol,
                domainWithPort: domainWithPort,
                fullUrl: window.location.href,
                amapVersion: this.amapConfig.version,
                // 域名白名单建议格式
                domainWhitelistSuggestions: [
                  currentHost,
                  currentPort ? domainWithPort : null,
                  `${currentProtocol}://${currentHost}`,
                  currentPort ? `${currentProtocol}://${domainWithPort}` : null,
                ].filter(Boolean),
              }
              
              console.error('JS API 地理编码错误 - 详细诊断信息:', diagnosticInfo)
              
              // 如果是域名错误，特别提示
              if (errorResult.includes('INVALID_USER_DOMAIN')) {
                console.group('🌐 域名白名单配置指南')
                console.warn('当前访问信息:')
                console.table({
                  '域名': currentHost,
                  '端口': currentPort || '默认',
                  '协议': currentProtocol,
                  '完整地址': domainWithPort,
                })
                console.warn('请在高德控制台添加以下域名到白名单（建议全部添加）:')
                diagnosticInfo.domainWhitelistSuggestions.forEach((domain, index) => {
                  console.warn(`  ${index + 1}. ${domain}`)
                })
                console.warn('配置位置: 高德控制台 > 应用管理 > 您的应用 > 域名白名单')
                console.groupEnd()
              }
              
              // 判断错误类型并提供具体建议
              let errorMessage = '地址解析失败'
              let suggestions = []
              
              if (errorResult.includes('INVALID_USER_DOMAIN')) {
                errorMessage = '域名白名单配置错误'
                suggestions = [
                  '当前访问域名: ' + domainWithPort,
                  '当前协议: ' + currentProtocol,
                  '请在高德控制台的"域名白名单"中添加以下域名（建议全部添加）:',
                  '  - ' + currentHost + ' （不带端口）',
                  currentPort ? '  - ' + domainWithPort + ' （带端口）' : '',
                  '  - ' + currentProtocol + '://' + currentHost + ' （带协议）',
                  currentPort ? '  - ' + currentProtocol + '://' + domainWithPort + ' （完整格式）' : '',
                  '注意：',
                  '  1. 域名白名单支持通配符，如 *.example.com',
                  '  2. 开发环境建议添加 localhost 和 127.0.0.1',
                  '  3. 如果使用 IP 访问，也需要添加 IP 地址到白名单',
                  '  4. 配置后可能需要等待几分钟生效',
                ].filter(Boolean) // 过滤空字符串
              } else if (errorResult.includes('USERKEY_PLAT_NOMATCH')) {
                errorMessage = 'Key 平台类型不匹配'
                suggestions = [
                  '1. 确认在高德控制台创建的是"Web 端(JS API)"类型的 Key',
                  '2. 检查 Key 是否与当前使用的 Key 一致',
                  '3. 如果 Key 类型正确但仍报错，请尝试重新创建 Key',
                ]
              } else if (errorResult.includes('USERKEY_NOT_AUTHORIZED')) {
                errorMessage = 'Key 未授权或服务未开通'
                suggestions = [
                  '1. 在高德控制台检查 Key 的服务权限，确保"Web 服务 API"已开通',
                  '2. 检查 Key 是否已过期或被禁用',
                  '3. 确认 Key 的配额是否充足',
                ]
              } else if (errorResult.includes('USERKEY')) {
                errorMessage = 'Key 配置错误'
                suggestions = [
                  '1. 确认 Key 是否正确（当前 Key 前8位: ' + this.amapConfig.key.substring(0, 8) + '）',
                  '2. 检查域名白名单：当前域名 "' + currentHost + '" 是否已添加到白名单',
                  '3. 如果启用了安全密钥，请配置 VUE_APP_AMAP_SECURITY_JS_CODE',
                  '4. 检查 Key 是否已过期',
                ]
              } else {
                suggestions = [
                  '1. 检查网络连接',
                  '2. 查看浏览器控制台完整错误信息',
                  '3. 尝试刷新页面重试',
                ]
              }
              
              console.warn('解决方案建议:', suggestions)
              
              // JS API 失败，尝试使用 REST API 作为备用方案
              // 注意：REST API 需要使用 Web 服务端 Key
              console.log('JS API 失败，尝试使用 REST API 作为备用方案...')
              const restResult = await this.getAddressByLngLatRestAPI(lng, lat)
              if (restResult.success) {
                this.selectedAddress = restResult.address
                this.selectedDetailAddress = restResult.detailAddress
                this.$message.success('地址解析成功（使用 REST API 备用方案）')
                return
              } else {
                // REST API 也失败，显示错误信息
                let userMessage = errorMessage
                const allSuggestions = [...suggestions]
                
                if (restResult.errorCode) {
                  if (restResult.detailedSuggestions && restResult.detailedSuggestions.length > 0) {
                    allSuggestions.push(...restResult.detailedSuggestions)
                    userMessage = `${errorMessage}。REST API 错误：${restResult.suggestion || restResult.message}`
                  } else {
                    userMessage = `${errorMessage}。REST API 错误：${restResult.message}`
                  }
                }
                
                // 显示错误消息和建议
                if (errorResult.includes('INVALID_USER_DOMAIN')) {
                  const domainMsg = `域名白名单配置错误。当前域名: ${domainWithPort}，请在高德控制台添加域名白名单（查看控制台获取详细配置指南）`
                  this.$message.warning(domainMsg, 10)
                } else {
                  this.$message.warning(userMessage, 8)
                }
                
                // 输出详细的诊断信息
                console.group('🔍 地理编码错误诊断')
                console.error('JS API 错误信息:', errorMessage)
                if (restResult.errorCode) {
                  console.error('REST API 错误信息:', restResult.message)
                  console.error('错误码:', restResult.errorCode)
                }
                if (allSuggestions.length > 0) {
                  console.warn('建议解决方案:')
                  allSuggestions.forEach((s, i) => console.warn(`  ${i + 1}. ${s}`))
                }
                console.warn('诊断信息:', diagnosticInfo)
                console.groupEnd()
                
                if (!this.selectedAddress) {
                  this.selectedAddress = ''
                }
                if (!this.selectedDetailAddress) {
                  this.selectedDetailAddress = ''
                }
              }
              
              return
            }
            
            // 检查成功状态
            if (status === 'complete' && result) {
              // 检查 result.info 是否为 'OK'
              if (result.info !== 'OK') {
                console.error('地理编码失败，result.info 不是 OK:', result.info)
                console.error('完整结果:', JSON.stringify(result, null, 2))
                this.$message.warning(`地址解析失败: ${result.info || '未知错误'}`, 8)
                this.handleGeocodeError(searchItem)
                return
              }
              
              const regeocode = result.regeocode
              if (!regeocode) {
                console.warn('地理编码结果中没有 regeocode 数据')
                console.warn('完整结果:', JSON.stringify(result, null, 2))
                this.$message.warning('地址解析失败：未获取到地址信息', 8)
                this.handleGeocodeError(searchItem)
                return
              }

            // 如果是从搜索结果选择的，使用搜索结果的地址信息
            if (searchItem) {
              this.selectedAddress =
                searchItem.address || regeocode.formattedAddress || '地址解析失败'
              // 构建完整地址信息：省市区 + 街道 + 详细地址
              const addressComponent = regeocode.addressComponent
              if (addressComponent) {
                // 辅助函数：提取地址组件值（可能是字符串、对象或数组）
                const getAddressValue = (value) => {
                  if (!value) return ''
                  if (typeof value === 'string') return value
                  if (Array.isArray(value)) {
                    // 如果是数组，取第一个元素
                    return getAddressValue(value[0])
                  }
                  if (typeof value === 'object') {
                    // 优先取 name 属性
                    if (value.name) return String(value.name)
                    // 如果没有 name，尝试取其他可能的属性
                    if (value.value) return String(value.value)
                    if (value.text) return String(value.text)
                    // 如果都没有，返回空字符串，避免显示 [object Object]
                    return ''
                  }
                  return String(value)
                }
                
                // 提取地址组件值
                const province = getAddressValue(addressComponent.province)
                const city = getAddressValue(addressComponent.city)
                const district = getAddressValue(addressComponent.district)
                const township = getAddressValue(addressComponent.township)
                const street = getAddressValue(addressComponent.street)
                const streetNumber = getAddressValue(addressComponent.streetNumber)
                
                // 构建完整地址，使用数组过滤空值后拼接
                const addressParts = [province, city, district, township, street, streetNumber].filter(Boolean)
                let fullAddress = addressParts.join('')
                // 如果有格式化地址且与构建的地址不同，优先使用格式化地址
                if (
                  regeocode.formattedAddress &&
                  regeocode.formattedAddress !== fullAddress
                ) {
                  fullAddress = regeocode.formattedAddress
                }
                this.selectedDetailAddress =
                  fullAddress ||
                  searchItem.fullAddress ||
                  regeocode.formattedAddress ||
                  '地址解析失败'
              } else {
                this.selectedDetailAddress =
                  searchItem.fullAddress ||
                  regeocode.formattedAddress ||
                  '地址解析失败'
              }
            } else {
              // 直接点击地图获取的地址
              this.selectedAddress = regeocode.formattedAddress || '地址解析失败'
              const addressComponent = regeocode.addressComponent
              if (addressComponent) {
                // 辅助函数：提取地址组件值（可能是字符串、对象或数组）
                const getAddressValue = (value) => {
                  if (!value) return ''
                  if (typeof value === 'string') return value
                  if (Array.isArray(value)) {
                    // 如果是数组，取第一个元素
                    return getAddressValue(value[0])
                  }
                  if (typeof value === 'object') {
                    // 优先取 name 属性
                    if (value.name) return String(value.name)
                    // 如果没有 name，尝试取其他可能的属性
                    if (value.value) return String(value.value)
                    if (value.text) return String(value.text)
                    // 如果都没有，返回空字符串，避免显示 [object Object]
                    return ''
                  }
                  return String(value)
                }
                
                // 提取地址组件值
                const province = getAddressValue(addressComponent.province)
                const city = getAddressValue(addressComponent.city)
                const district = getAddressValue(addressComponent.district)
                const township = getAddressValue(addressComponent.township)
                const street = getAddressValue(addressComponent.street)
                const streetNumber = getAddressValue(addressComponent.streetNumber)
                
                // 构建完整地址，使用数组过滤空值后拼接
                const addressParts = [province, city, district, township, street, streetNumber].filter(Boolean)
                const fullAddress = addressParts.join('')
                
                this.selectedDetailAddress =
                  fullAddress || regeocode.formattedAddress || '地址解析失败'
              } else {
                this.selectedDetailAddress = regeocode.formattedAddress || '地址解析失败'
              }
            }
            
            // 验证地址是否成功解析
            if (this.selectedAddress && this.selectedAddress !== '地址解析失败' && 
                this.selectedDetailAddress && this.selectedDetailAddress !== '地址解析失败') {
            } else {
              console.warn('⚠️ 地址解析结果可能不完整:', {
                selectedAddress: this.selectedAddress,
                selectedDetailAddress: this.selectedDetailAddress,
              })
              this.$message.warning('地址解析结果可能不完整，请检查或手动输入', 5)
            }
          } else {
            console.error('地理编码失败:', { status, result })
            // 检查是否是 Key 相关错误
            if (result && typeof result === 'string') {
              if (result.includes('USERKEY_PLAT_NOMATCH') || result.includes('USERKEY')) {
                console.error('地理编码 Key 错误，尝试使用 REST API:', result)
                // JS API 失败，尝试使用 REST API 作为备用方案
                const restResult = await this.getAddressByLngLatRestAPI(lng, lat)
                if (restResult.success) {
                  this.selectedAddress = restResult.address
                  this.selectedDetailAddress = restResult.detailAddress
                  this.$message.success('地址解析成功（使用 REST API 备用方案）')
                } else {
                  this.$message.warning('地址解析失败，请检查高德地图配置', 8)
                  if (restResult.errorCode && restResult.detailedSuggestions && restResult.detailedSuggestions.length > 0) {
                    console.group('🔍 REST API 错误诊断')
                    console.error('错误信息:', restResult.message)
                    console.error('错误码:', restResult.errorCode)
                    console.warn('建议解决方案:')
                    restResult.detailedSuggestions.forEach((s, i) => console.warn(`  ${i + 1}. ${s}`))
                    console.groupEnd()
                  }
                  this.handleGeocodeError(searchItem)
                }
                return
              }
            }
            // 其他错误也尝试使用 REST API
            console.log('尝试使用 REST API 作为备用方案')
            const restResult = await this.getAddressByLngLatRestAPI(lng, lat)
            if (restResult.success) {
              this.selectedAddress = restResult.address
              this.selectedDetailAddress = restResult.detailAddress
              this.$message.success('地址解析成功（使用 REST API 备用方案）')
            } else {
              this.$message.warning('地址解析失败，请手动输入地址或检查高德地图配置', 8)
              if (restResult.errorCode && restResult.detailedSuggestions && restResult.detailedSuggestions.length > 0) {
                console.group('🔍 REST API 错误诊断')
                console.error('错误信息:', restResult.message)
                console.error('错误码:', restResult.errorCode)
                console.warn('建议解决方案:')
                restResult.detailedSuggestions.forEach((s, i) => console.warn(`  ${i + 1}. ${s}`))
                console.groupEnd()
              }
              this.handleGeocodeError(searchItem)
            }
          }
        })
        } else {
          // 如果 JS API 不可用，使用 REST API
          console.log('JS API 不可用，使用 REST API')
          const restResult = await this.getAddressByLngLatRestAPI(lng, lat)
          if (restResult.success) {
            this.selectedAddress = restResult.address
            this.selectedDetailAddress = restResult.detailAddress
            this.$message.success('地址解析成功（使用 REST API）')
          } else {
            this.$message.warning('无法自动解析地址，请手动输入地址', 8)
            if (restResult.errorCode && restResult.detailedSuggestions && restResult.detailedSuggestions.length > 0) {
              console.group('🔍 REST API 错误诊断')
              console.error('错误信息:', restResult.message)
              console.error('错误码:', restResult.errorCode)
              console.warn('建议解决方案:')
              restResult.detailedSuggestions.forEach((s, i) => console.warn(`  ${i + 1}. ${s}`))
              console.groupEnd()
            }
            
            if (!this.selectedAddress) {
              this.selectedAddress = ''
            }
            if (!this.selectedDetailAddress) {
              this.selectedDetailAddress = ''
            }
          }
        }
      } catch (error) {
        console.error('地理编码异常:', error)
        // 异常时也尝试使用 REST API
        try {
          const [lng, lat] = Array.isArray(position) ? position : [position.lng || position.getLng(), position.lat || position.getLat()]
          const restResult = await this.getAddressByLngLatRestAPI(lng, lat)
          if (restResult.success) {
            this.selectedAddress = restResult.address
            this.selectedDetailAddress = restResult.detailAddress
            this.$message.success('地址解析成功（使用 REST API 备用方案）')
          } else {
            let userMessage = '地址解析异常，请手动输入地址'
            if (restResult.errorCode && restResult.detailedSuggestions && restResult.detailedSuggestions.length > 0) {
              userMessage = `地址解析失败：${restResult.suggestion || restResult.message}`
              console.group('🔍 REST API 错误诊断')
              console.error('错误信息:', restResult.message)
              console.error('错误码:', restResult.errorCode)
              console.warn('建议解决方案:')
              restResult.detailedSuggestions.forEach((s, i) => console.warn(`  ${i + 1}. ${s}`))
              console.groupEnd()
            } else if (restResult.errorCode) {
              userMessage = `地址解析失败：${restResult.message}。请检查高德地图 Key 配置`
            } else {
              userMessage = '地址解析异常: ' + (error.message || '未知错误')
            }
            
            this.$message.warning(userMessage, 8)
            this.handleGeocodeError(searchItem)
          }
        } catch (restError) {
          console.error('REST API 调用异常:', restError)
          this.$message.warning('地址解析异常，请手动输入地址: ' + (error.message || '未知错误'), 8)
          this.handleGeocodeError(searchItem)
        }
      }
    },
    // 处理地理编码错误
    handleGeocodeError(searchItem) {
      this.selectedAddress = searchItem
        ? searchItem.address || '地址解析失败'
        : '地址解析失败'
      this.selectedDetailAddress = searchItem
        ? searchItem.fullAddress || '地址解析失败'
        : '地址解析失败'
      this.$message.warning('地址解析失败，请重试或手动输入地址')
    },
    // 确认选择位置
    handleConfirm() {
      if (!this.selectedLng || !this.selectedLat) {
        this.$message.warning('请先在地图上选择位置或搜索选择地点')
        return
      }
      // 触发确认事件，传递选择的数据
      $emit(this, 'confirm', {
        longitude: this.selectedLng,
        latitude: this.selectedLat,
        address: this.selectedDetailAddress || this.selectedAddress,
      })
      this.$message.success('位置已选择')
    },
    // 取消选择
    handleCancel() {
      $emit(this, 'cancel')
    },
    // 销毁地图
    destroyMap() {
      if (this.map) {
        try {
          this.map.destroy()
        } catch (e) {
          console.warn('销毁地图时出错:', e)
        }
        this.map = null
        this.marker = null
      }
      if (this.placeSearch) {
        this.placeSearch = null
      }
    },
  },
  beforeUnmount() {
    this.destroyMap()
  },
  emits: ['confirm', 'cancel'],
}
</script>

<style scoped>
/* 按钮圆角设为 4px */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 黑色背景的按钮（primary类型）背景颜色设为 #165DFF */
:deep(.ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

:deep(.ant-btn-primary:hover),
:deep(.ant-btn-primary:focus) {
  background-color: #0e4acc !important;
  border-color: #0e4acc !important;
}
</style>

<style>
/* 参照beacon页面，使用限定作用域的类名，只针对地图选点弹窗内的样式 */
/* 搜索输入框左侧圆角设为 4px - 只针对搜索输入框 */
.map-picker-modal .map-search-wrapper .ant-input-search .ant-input,
.map-picker-modal .map-search-wrapper .ant-input-search input {
  border-radius: 4px 0 0 4px !important;
}

/* 搜索按钮右侧圆角设为 4px */
.map-picker-modal .map-search-wrapper .ant-input-search .ant-input-group-addon,
.map-picker-modal .map-search-wrapper .ant-input-search .ant-input-search-button {
  border-radius: 0 4px 4px 0 !important;
}

.map-picker-modal .map-search-wrapper .ant-input-search .ant-input-group-addon .ant-btn,
.map-picker-modal .map-search-wrapper .ant-input-search .ant-input-search-button .ant-btn {
  border-radius: 0 4px 4px 0 !important;
}

/* 其他输入框样式 - 参照beacon页面的方式，保持4px圆角 */
.map-picker-modal .ant-input,
.map-picker-modal .ant-input:hover,
.map-picker-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.map-picker-modal .ant-input-affix-wrapper,
.map-picker-modal .ant-input-affix-wrapper:hover,
.map-picker-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.map-picker-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.map-picker-modal .ant-select-selector,
.map-picker-modal .ant-select-selector:hover,
.map-picker-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.map-picker-modal .ant-picker,
.map-picker-modal .ant-picker:hover,
.map-picker-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.map-picker-modal .ant-input-number,
.map-picker-modal .ant-input-number:hover,
.map-picker-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.map-picker-modal .ant-btn {
  border-radius: 4px !important;
}
</style>
